import { LitElement, html, css } from 'lit';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';

class CbomProduct extends LitElement {
  // Properties
  static properties = {
    id: { type: Number },
    category: { type: Object },
    name: {},
    current: { type: Boolean },
    price: {},
    src: { type: String },
    selected: { type: Boolean },
    parent: { type: Boolean },
    isMobile: { type: Boolean },
  };

  // Styles
  static styles = css`
    article {
      display: flex;
      align-items: center;
      justify-content: left;
      font-family: Arial, sans-serif;
      padding: 5px 10px;
      color: #666666;
      min-height: 64px;
      cursor: pointer;
      border-bottom: 1px solid #f4f4f4;
    }
    article.is-mobile .price {
      color: #434649;
      font-weight: 700;
    }
    article.is-parent {
      border-top: none;
    }
    article h3 {
      font-size: 15px;
      font-weight: normal;
      margin: 0;
    }
    article:hover {
      background-color: rgba(45, 156, 219, 0.1);
    }
    article[selected] {
      background-color: rgba(45, 156, 219, 0.2);
    }
    article[option] {
      color: #666666;
    }
    article img {
      margin-right: 10px;
      border: 1px solid #828282;
      border-radius: 3px;
      width: 48px;
      height: 48px;
    }
    article .price {
      margin-left: auto;
      white-space: nowrap;
      padding-left: 10px;
      padding-right: 19px;
      font-size: 15px;
      color: rgba(102, 102, 102, 1);
    }
    .is-mobile .price {
      padding-right: 0;
    }
    .is-current {
      cursor: default;
      color: #434649;
    }
    .is-parent {
      cursor: pointer;
    }
  `;

  constructor() {
    super();
    this._openDelay = 100;
    this._closeDelay = 400;
  }

  // Events
  _onProductClick = () => {
    if (!this.parent) {
      this.dispatchEvent(
        new CustomEvent('cbomproductclick', {
          detail: {
            id: this.id,
            category: this.category,
          },
        })
      );
    }
  };

  _onProductMouseenter = () => {
    if (!this.parent && !this.isMobile) {
      // Clearing timeouts as any running would affect this function
      clearTimeout(window.mouseEnterTimeout);
      clearTimeout(window.mouseLeaveTimeout);
      window.mouseEnterTimeout = setTimeout(() => {
        this.dispatchEvent(
          new CustomEvent('cbomproductmouseenter', {
            detail: {
              id: this.id,
              category: this.category,
              productElement: this,
            },
          })
        );
      }, this._openDelay);
    }
  };

  _onProductMouseleave = () => {
    if (!this.parent && !this.isMobile) {
      // Clearing timeouts as any running would affect this function
      clearTimeout(window.mouseEnterTimeout);
      clearTimeout(window.mouseLeaveTimeout);
      window.mouseLeaveTimeout = setTimeout(() => {
        this.dispatchEvent(
          new CustomEvent('cbomproductmouseleave', {
            detail: {
              id: this.id,
              category: this.category,
            },
          })
        );
      }, this._closeDelay);
    }
  };

  // Renders
  renderImage() {
    return this.src ? html`<img src="${this.src}" />` : null;
  }

  renderPrice() {
    return this.price
      ? html`<span class="price">${unsafeHTML(this.price)}</span>`
      : null;
  }

  render() {
    return html`
      <article
        @click=${this._onProductClick}
        @mouseenter=${this._onProductMouseenter}
        @mouseleave=${this._onProductMouseleave}
        ?selected=${this.selected}
        data-productid="${this.id}"
        class="
          ${this.current ? 'is-current' : ''}
          ${this.isMobile ? 'is-mobile' : ''}
          ${this.parent ? 'is-parent' : ''}
        "
      >
        ${this.renderImage()}
        <h3>${this.name}</h3>
        ${this.renderPrice()}
      </article>
    `;
  }
}

customElements.define('cbom-product', CbomProduct);
